import { Badge, Checkbox } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  assignmentDateCss,
  assignmentRowContentCss,
  separatorCss,
} from "./AssignModal.style.js";

const isAlreadyAssigned = (assignment, contentMemberIds) => {
  // Check to see if any of the content attempting to be assigned already
  // belongs to the selected assignment.
  const assignmentContentIds = assignment?.assignment_members?.map(
    (assignmentMember) => assignmentMember?.content?.content_id,
  );
  const already = assignmentContentIds.some((contentId) =>
    contentMemberIds?.includes(contentId),
  );
  return already;
};

const renderAssignmentDate = (isAlreadyAssigned, assignment) => {
  const dateAssigned =
    assignment?.assignment_classrooms[0]?.date_assigned ||
    assignment?.date_assigned;
  const isDraft = assignment?.is_draft;

  if (isAlreadyAssigned) {
    return (
      <Badge
        __cssFor={assignmentDateCss}
        text="Some content may already be added"
        flavor={Badge.flavor.solid}
        color={Badge.color.grey}
      />
    );
  } else {
    if (isDraft) {
      return (
        <Badge
          __cssFor={assignmentDateCss}
          text="Draft"
          flavor={Badge.flavor.solid}
          color={Badge.color.grey}
        />
      );
    } else {
      let assignmentFormattedDate;
      try {
        if (dateAssigned)
          assignmentFormattedDate = new Date(dateAssigned).toLocaleDateString();
      } catch (_error) {}
      return (
        <Badge
          __cssFor={assignmentDateCss}
          text={
            assignmentFormattedDate
              ? `Assigned on ${assignmentFormattedDate}`
              : "Assigned"
          }
          flavor={Badge.flavor.solid}
          color={Badge.color.grey}
        />
      );
    }
  }
};

const AssignmentRow = ({
  contentMemberIds,
  assignment,
  handleClick,
  isLastItem = false,
  alreadySelected = {},
}) => {
  const { content_id: contentId, title } = assignment;
  const isChecked = !!alreadySelected[contentId];
  const alreadyAssigned = isAlreadyAssigned(assignment, contentMemberIds);

  return (
    <>
      <li css={assignmentRowContentCss}>
        <Checkbox
          checked={isChecked}
          label={title}
          name="assignment"
          onClick={() => handleClick(assignment)}
          value={contentId}
        />
        {renderAssignmentDate(alreadyAssigned, assignment)}
      </li>
      {!isLastItem && <hr css={separatorCss} />}
    </>
  );
};
AssignmentRow.propTypes = {
  alreadySelected: PropTypes.arrayOf(PropTypes.string),
  contentMemberIds: PropTypes.arrayOf(PropTypes.string),
  assignment: {
    assignment_classrooms: PropTypes.arrayOf({
      date_assigned: PropTypes.string,
    }),
    date_assigned: PropTypes.string,
    is_draft: PropTypes.bool,
  },
  isLastItem: PropTypes.bool,
  handleClick: PropTypes.func,
};

export default AssignmentRow;
